
import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginService } from './login/login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private loginService: LoginService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
    const token = this.loginService.getToken();

    if (token) {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
        url: `${req.url}`,
        // FIXME: can we add the header only local or if debug flag is set?!
        params: (req.params ? req.params : new HttpParams()).set('XDEBUG_SESSION', 'XDEBUG')
      });
      return next.handle(authReq);
    }

    return next.handle(req.clone({ url: `${req.url}` }));
  }

}
